import { Injectable } from '@angular/core';
import { ENTERPRISES_URL, USERS_URL, CONTACTS_SUFFIX, USER_CREATE_URL, BADGES_URL, ANONYM_USER_URL, CONTACTS_EDIT, ENTERPRISE_TOTAL_BADGESINFO_URL } from '../../shared/constants/urls';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomStorageService } from '../custom-storage/custom-storage.service';
import { Enterprise } from '../../models/enterprise.interface';
import { User } from 'src/app/models/user.interface';

@Injectable({
  providedIn: 'root',
})
export class EnterpriseService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly storageService: CustomStorageService
  ) {}


  getHeader() {
    const headers = new HttpHeaders({
      'content-Type': 'application/json',
      authorization: 'bearer ' + this.storageService.getToken(),
    });
    return headers;
  }

  getEnterpriseById(id) {
    return this.httpClient.get(ENTERPRISES_URL + id, { headers: this.getHeader() });
  }

  updateEnterprise(enterprise, contactId): Observable<Enterprise> {
    const options = {
      headers: new HttpHeaders({
        enctype: 'mutlipart/form-data',
        Authorization: 'bearer ' + this.storageService.getToken(),
      }),
    };
    return this.httpClient.put<Enterprise>(
      CONTACTS_EDIT + contactId,
      enterprise,
      options
    );
  }

  getCreditAllHistory(id, limit , offset) {
    const query = '?enterprise=' + id + '&limit=' + limit + '&offset=' + offset;

    return this.httpClient.get(ENTERPRISE_TOTAL_BADGESINFO_URL + query, { headers: this.getHeader() });
  }

  findById(id: string) {
    return this.httpClient.get(ENTERPRISES_URL + id);
  }

  setLocalData(enterprise) {
    this.storageService.setEnterprise(enterprise);
  }

  getLocalData() {
    const enterprise = this.storageService.getEnterprise();
    return enterprise;
  }

  getEmployees() {
    return this.httpClient.get(USERS_URL, { headers: this.getHeader() });
  }

  createEmployee(enterpriseId: string, createEmployeeBody: any) {
    const headers = new HttpHeaders({
      enctype: 'multipart/form-data',
      authorization: 'bearer ' + this.storageService.getToken(),
    });
    return this.httpClient.post(USER_CREATE_URL, createEmployeeBody, { headers });
  }

  deleteEmployee(employeeId: string) {
    return this.httpClient.delete(USERS_URL + employeeId, { headers: this.getHeader() });
  }

  getContacts() {
    return this.httpClient.get(ENTERPRISES_URL + CONTACTS_SUFFIX, { headers: this.getHeader() });
  }

  createContact(contact) {
    return this.httpClient.post(ENTERPRISES_URL + CONTACTS_SUFFIX, contact, { headers: this.getHeader() });
  }

  getUserById(id: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        enctype: 'multipart/form-data',
        Authorization: 'bearer ' + this.storageService.getToken(),
      })
    };
    return this.httpClient.get<User>(USERS_URL + id, options);
  }

  updateEmployee(id: string, user: any): Observable<User> {
    const options = {
      headers: new HttpHeaders({
        enctype: 'multipart/form-data',
        Authorization: 'bearer ' + this.storageService.getToken(),
      })
    };
    return this.httpClient.put<User>(USERS_URL + id, user, options);
  }

  updatePerference(enterprise): Observable<Enterprise> {
    const options = {
      headers: new HttpHeaders({
        enctype: 'multipart/form-data',
        Authorization: 'bearer ' + this.storageService.getToken(),
      })
    };
    const enterpriseId: any = this.storageService.getEnterprise().id;
    return this.httpClient.put<Enterprise>(ENTERPRISES_URL + enterpriseId, enterprise, options);
  }

  anonymEmployee(employeeId: string) {
    return this.httpClient.delete(ANONYM_USER_URL + employeeId, { headers: this.getHeader() });
  }

  getAnonymousUsers() {
    const headers = new HttpHeaders({
      enctype: 'multipart/form-data',
      authorization: 'bearer ' + this.storageService.getToken(),
    });
    return this.httpClient.get(USERS_URL + '?anonymous=true', { headers });
  }

  getBadgeByEmployee(userId) {
    const query = '?userId=' + userId;
    return this.httpClient.get(BADGES_URL + query, { headers: this.getHeader() });
  }
}
